const setSpouseCitizenId = (data = null) => {
  return {
    type: 'SET_SPOUSECITIZENID',
    data
  }
}

export default {
  setSpouseCitizenId,
}
